export default __webpack_public_path__ + "static/media/preloader.adffb50b.gif";